import { useEffect } from 'react';
import { useState }  from 'react';
import useRouter     from './use_router';


export default function useRouteParams() {
  const router                = useRouter();
  const [ params, setParams ] = useState({});

  function getParamsFromRoute(route) {
    setParams(route.params);
  }

  useEffect(function getParamsOnMount() {
    if (router) {
      const { url } = router.currentRoute;
      const route   = url && router.findMatchingRoute(url);
      if (route)
        getParamsFromRoute(route);
    }
  }, [ router ]);

  useEffect(function getParamsOnRouteChange() {
    if (router)
      router.on('routeChange', getParamsFromRoute);

    return () => {
      if (router)
        router.off('routeChange', getParamsFromRoute);
    };
  }, [ router ]);

  return params;
}
